import React from "react";

const DEFAULT_TEXT = "EMİNEVİM";

const EminevimLoading = ({
  subtext,
  className = "",
  compact = false,
  text = DEFAULT_TEXT,
}) => {
  const letters = [...text];
  const staggerSeconds = compact ? 0.11 : 0.13;
  const pulseDurationSeconds = compact ? 1.35 : 1.55;

  const rootClassName = [
    "t-eminevimLoading",
    compact ? "t-eminevimLoading--compact" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={rootClassName} role="status" aria-live="polite" aria-label="Yükleniyor">
      <div className="t-eminevimLoading-letters" aria-hidden="true">
        {letters.map((letter, index) => (
          <span
            key={`${letter}-${index}`}
            className="t-eminevimLoading-letter"
            style={{
              "--letter-delay": `${index * staggerSeconds}s`,
              "--letter-duration": `${pulseDurationSeconds}s`,
            }}
          >
            <span className="t-eminevimLoading-letterText">{letter}</span>
            <span className="t-eminevimLoading-letterShine" aria-hidden="true" />
          </span>
        ))}
      </div>
      {subtext ? <p className="t-eminevimLoading-subtext">{subtext}</p> : null}
    </div>
  );
};

export default EminevimLoading;
